import React, { useState } from "react";
import styles from "./index.module.scss";
import InvestorListingSkeleton from "../../../skeleton/inv-acc-skeleton";
import CallingPipelineWebCard from "../calling-pipeline-web-card";
import { useCallingPipelineList } from "../../../hooks/react-query/calling-pipeline/useCallingPipelineList";
import CallingPipelineMobileCard from "../calling-pipeline-mobile-card";
import { formatAbbreviatedCurrencyWithoutSymbol } from "../../../utils/utils";

export default function CallingPipelineListing() {
  const { data, isLoading } = useCallingPipelineList();
  const [showActive, setShowActive] = useState(false);
  const [showPendingFollowUp, setShowPendingFollowUp] = useState(false);
  const [showColdDoNotPursue, setShowColdDoNotPursue] = useState(false);

  const hasActive = data?.active?.length > 0;
  const hasPendingFollowUp = data?.pendingFollowUp?.length > 0;
  const hasColdDoNotPursue = data?.coldDoNotPursue?.length > 0;
  const allEmpty = !hasActive && !hasPendingFollowUp && !hasColdDoNotPursue;

  return (
    <div className={styles.investorListing}>
      {hasActive && (
        <div className={styles.listingHeader}>
          <img
            src="/images/calling-pipeline-down-arrow.svg"
            className={`${styles.arrow} ${showActive ? styles.right : ""}`}
            alt="down-arrow"
            width={36}
            height={36}
            onClick={() => setShowActive((prev) => !prev)}
          />
          <div>
            <div className={styles.headerTitle}>Active</div>
            <div className={styles.headerSubTitle}>
              {data?.active?.length}{" "}
              {data?.active?.length > 1 ? "Investors " : "Investor "}
              <span className={styles.dot}>•</span>{" "}
              {formatAbbreviatedCurrencyWithoutSymbol(
                data?.active?.reduce((a: any, b: any) => a + b.askingPrice, 0),
                "USD"
              )}{" "}
              properties price in total
            </div>
          </div>
        </div>
      )}
      <div className={`${showActive ? styles.hide : ""} ${styles.invList}`}>
        {isLoading && <InvestorListingSkeleton />}
        {!isLoading &&
          hasActive &&
          data?.active?.map((item: any, index: number) => (
            <div
              key={`active-inv-list-${index}-${item.accountName}`}
              className={styles.invListItemWrapper}
            >
              <CallingPipelineWebCard
                id={item?.id}
                portalStatus={item?.portalStatus}
                propertySfid={item?.propertySfid}
                accountSfid={item?.accountSfid}
                bidCount={item?.bidCount}
                createdAt={item.createdAt}
                address={item.address}
                checkoutId={item.checkoutId}
                propertyId={item.propertyId}
                accountId={item.accountId}
                accountName={item.accountName}
                expiryAt={item.expiryAt}
                releasedAt={item.releasedAt}
                email={item?.email}
                plainPhone={item?.plainPhone}
                contacts={item?.contacts}
                callRecords={item?.lastCall}
                engmtStatus={item?.engmtStatus}
              />
              <CallingPipelineMobileCard
                portalStatus={item?.portalStatus}
                propertySfid={item?.propertySfid}
                accountSfid={item?.accountSfid}
                bidCount={item?.bidCount}
                createdAt={item.createdAt}
                address={item.address}
                checkoutId={item.checkoutId}
                propertyId={item.propertyId}
                accountId={item.accountId}
                accountName={item.accountName}
                expiryAt={item.expiryAt}
                releasedAt={item.releasedAt}
                email={item?.email}
                plainPhone={item?.plainPhone}
                contacts={item?.contacts}
                callRecords={item?.lastCall}
                engmtStatus={item?.engmtStatus}
              />
            </div>
          ))}
      </div>
      {hasPendingFollowUp && (
        <div className={styles.listingHeader}>
          <img
            src="/images/calling-pipeline-down-arrow.svg"
            className={`${styles.arrow} ${
              showPendingFollowUp ? styles.right : ""
            }`}
            alt="down-arrow"
            width={36}
            height={36}
            onClick={() => setShowPendingFollowUp((prev) => !prev)}
          />
          <div>
            <div className={styles.headerTitle}>Pending Follow Up</div>
            <div className={styles.headerSubTitle}>
              {data?.pendingFollowUp?.length}{" "}
              {data?.pendingFollowUp?.length > 1 ? "Investors " : "Investor "}
              <span className={styles.dot}>•</span>{" "}
              {formatAbbreviatedCurrencyWithoutSymbol(
                data?.pendingFollowUp?.reduce(
                  (a: any, b: any) => a + b.askingPrice,
                  0
                ),
                "USD"
              )}{" "}
              properties price in total
            </div>
          </div>
        </div>
      )}
      <div
        className={`${showPendingFollowUp ? styles.hide : ""} ${
          styles.invList
        }`}
      >
        {isLoading && <InvestorListingSkeleton />}
        {!isLoading &&
          hasPendingFollowUp &&
          data?.pendingFollowUp?.map((item: any, index: number) => (
            <div
              key={`pending-inv-list-${index}-${item.accountName}`}
              className={styles.invListItemWrapper}
            >
              <CallingPipelineWebCard
                id={item?.id}
                portalStatus={item?.portalStatus}
                propertySfid={item?.propertySfid}
                accountSfid={item?.accountSfid}
                bidCount={item?.bidCount}
                createdAt={item.createdAt}
                address={item.address}
                checkoutId={item.checkoutId}
                propertyId={item.propertyId}
                accountId={item.accountId}
                accountName={item.accountName}
                expiryAt={item.expiryAt}
                releasedAt={item.releasedAt}
                email={item?.email}
                plainPhone={item?.plainPhone}
                contacts={item?.contacts}
                callRecords={item?.lastCall}
                engmtStatus={item?.engmtStatus}
              />
              <CallingPipelineMobileCard
                portalStatus={item?.portalStatus}
                propertySfid={item?.propertySfid}
                accountSfid={item?.accountSfid}
                bidCount={item?.bidCount}
                createdAt={item.createdAt}
                address={item.address}
                checkoutId={item.checkoutId}
                propertyId={item.propertyId}
                accountId={item.accountId}
                accountName={item.accountName}
                expiryAt={item.expiryAt}
                releasedAt={item.releasedAt}
                email={item?.email}
                plainPhone={item?.plainPhone}
                contacts={item?.contacts}
                callRecords={item?.lastCall}
                engmtStatus={item?.engmtStatus}
              />
            </div>
          ))}
      </div>
      {hasColdDoNotPursue && (
        <div className={styles.listingHeader}>
          <img
            src="/images/calling-pipeline-down-arrow.svg"
            className={`${styles.arrow} ${
              showColdDoNotPursue ? styles.right : ""
            }`}
            alt="down-arrow"
            width={36}
            height={36}
            onClick={() => setShowColdDoNotPursue((prev) => !prev)}
          />
          <div>
            <div className={styles.headerTitle}>Cold / Do Not Pursue</div>
            <div className={styles.headerSubTitle}>
              {data?.coldDoNotPursue?.length}{" "}
              {data?.coldDoNotPursue?.length > 1 ? "Investors " : "Investor "}
              <span className={styles.dot}>•</span>{" "}
              {formatAbbreviatedCurrencyWithoutSymbol(
                data?.coldDoNotPursue?.reduce(
                  (a: any, b: any) => a + b.askingPrice,
                  0
                ),
                "USD"
              )}{" "}
              properties price in total
            </div>
          </div>
        </div>
      )}
      <div
        className={`${showColdDoNotPursue ? styles.hide : ""} ${
          styles.invList
        }`}
      >
        {isLoading && <InvestorListingSkeleton />}
        {!isLoading &&
          hasColdDoNotPursue &&
          data?.coldDoNotPursue?.map((item: any, index: number) => (
            <div
              key={`cold-inv-list-${index}-${item.accountName}`}
              className={styles.invListItemWrapper}
            >
              <CallingPipelineWebCard
                id={item?.id}
                portalStatus={item?.portalStatus}
                propertySfid={item?.propertySfid}
                accountSfid={item?.accountSfid}
                bidCount={item?.bidCount}
                createdAt={item.createdAt}
                address={item.address}
                checkoutId={item.checkoutId}
                propertyId={item.propertyId}
                accountId={item.accountId}
                accountName={item.accountName}
                expiryAt={item.expiryAt}
                releasedAt={item.releasedAt}
                email={item?.email}
                plainPhone={item?.plainPhone}
                contacts={item?.contacts}
                callRecords={item?.lastCall}
                engmtStatus={item?.engmtStatus}
              />
              <CallingPipelineMobileCard
                portalStatus={item?.portalStatus}
                propertySfid={item?.propertySfid}
                accountSfid={item?.accountSfid}
                bidCount={item?.bidCount}
                createdAt={item.createdAt}
                address={item.address}
                checkoutId={item.checkoutId}
                propertyId={item.propertyId}
                accountId={item.accountId}
                accountName={item.accountName}
                expiryAt={item.expiryAt}
                releasedAt={item.releasedAt}
                email={item?.email}
                plainPhone={item?.plainPhone}
                contacts={item?.contacts}
                callRecords={item?.lastCall}
                engmtStatus={item?.engmtStatus}
              />
            </div>
          ))}
      </div>

      {!isLoading && allEmpty && (
        <div className={styles.noDataFound}>
          <img src="/images/no-data-found.svg" alt="No Data" />
          <p>No data found</p>
        </div>
      )}
    </div>
  );
}
